import PropTypes from "prop-types";
import Button from "components/Button";
import AppModal from "components/common/AppModal";
import FormTextarea from "components/form/FormTextarea";

export default function RejectCancellationRequestModal({
  open,
  request,
  rejectionNotes,
  notesError,
  submitting,
  onNotesChange,
  onClose,
  onSubmit,
}) {
  if (!request) return null;

  return (
    <AppModal
      open={open}
      title="Rejection reason"
      onClose={onClose}
      preventClose={submitting}
      maxWidth="md"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button type="button" onClick={onSubmit} disabled={submitting}>
            {submitting ? "Rejecting…" : "Reject request"}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-text-700">
          Provide a reason for rejecting the cancellation request for{" "}
          <span className="font-semibold text-text-900">{request.user_email_id}</span>.
        </p>

        <FormTextarea
          label="Rejection notes"
          name="rejectionNotes"
          value={rejectionNotes}
          onChange={onNotesChange}
          placeholder="e.g. Cancellation not permitted for this investment."
          rows={4}
          disabled={submitting}
          error={notesError}
        />
      </div>
    </AppModal>
  );
}

RejectCancellationRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  request: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    user_email_id: PropTypes.string,
  }),
  rejectionNotes: PropTypes.string.isRequired,
  notesError: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  onNotesChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
